import httpApi from '../api/httpApi';
import useSWR from 'swr';
import {
    CollectionFilterItem,
    CollectionFilterSWRProps,
} from '../../models/CollectionFilter';

const FILTER_URL = '/api/v1/products/filter-widget';

const useCollectionFilterSWR = (filter: CollectionFilterSWRProps) => {
    const fetch = (query, filter): Promise<CollectionFilterItem[]> => {
        return httpApi
            .post<{ widget: CollectionFilterItem[] }>(query, filter)
            .then((res) => {
                return res.getData().widget;
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(
        [FILTER_URL, filter],
        ([url, filter]) => fetch(url, filter),
        {
            dedupingInterval: 600000, // 10min
            errorRetryCount: 3,
        }
    );

    return {
        filterItems: data ? data : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
    };
};

export default useCollectionFilterSWR;
